export default "__VITE_ASSET__DPsWxC0p__"